import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { Col, Row } from 'react-flexbox-grid';
import { OverlayTrigger } from '@saucelabs/sl-component-overlay';
import { jobIconMap } from '@saucelabs/sl-component-job';

import OwnersPopover from './OwnersPopover';
import StatusPopover from './StatusPopover';
import PerformancePopover from './PerformancePopover';
import Styles from './List.styles';
import { JOB_STATUS_LIST } from './../ducks/filters/constants';
import { functions } from './../ducks/filters';

const AutomatedJobsFilters = ({
  clearStatuses,
  owners,
  ownership,
  selectOwner,
  showOwnersFilter,
  status,
  toggleStatus,
  togglePerformance,
  performance,
  username,
  isPerformanceEnabled,
}) => {
  const owner = (
    owners.find((user) => user.name === ((!ownership.name && username) || ownership.name)) ||
    functions.getUsernameFilter(ownership.name)
  );

  return (
    <Row>
      <Col xs={12}>
        <Row>
          <Col xs>
            <div className={Styles['filters-row']}>
              <div className={`label ${Styles['filter-text']}`}>Filter:</div>
              {showOwnersFilter && (
                <div className={Styles['filter-item']}>
                  <OverlayTrigger
                    overlay={OwnersPopover({
                      username,
                      owners,
                      ownership,
                      selectOwner,
                    })}
                    placement="bottom"
                    rootClose
                    trigger="click"
                  >
                    <div>
                      <span className={Styles['filter-title']}>Owner:</span>
                      {' '}
                      {owner.label}
                    </div>
                  </OverlayTrigger>
                </div>
              )}
              <div className={Styles['filter-item']}>
                <OverlayTrigger
                  overlay={StatusPopover({
                    clearStatuses,
                    status,
                    statusesList: JOB_STATUS_LIST,
                    statusesIconMap: jobIconMap,
                    toggleStatus,
                  })}
                  placement="bottom"
                  rootClose
                  trigger="click"
                >
                  <div>
                    <span className={Styles['filter-title']}>Status:</span>
                    {' '}
                    { status.join(', ') || 'All' }
                  </div>
                </OverlayTrigger>
              </div>
              {isPerformanceEnabled && (
                <div className={Styles['filter-item']}>
                  <OverlayTrigger
                    overlay={PerformancePopover({
                      performance,
                      togglePerformance,
                    })}
                    placement="bottom"
                    rootClose
                    trigger="click"
                  >
                    <div>
                      <span className={Styles['filter-title']}>Performance:</span>
                      {` ${performance} Score`}
                    </div>
                  </OverlayTrigger>
                </div>
              )}
            </div>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

AutomatedJobsFilters.propTypes = {
  clearStatuses: PropTypes.func.isRequired,
  isPerformanceEnabled: PropTypes.bool,
  owners: PropTypes.array.isRequired,
  ownership: PropTypes.object.isRequired,
  performance: PropTypes.string,
  selectOwner: PropTypes.func.isRequired,
  showOwnersFilter: PropTypes.bool.isRequired,
  status: ImmutablePropTypes.list.isRequired,
  togglePerformance: PropTypes.func,
  toggleStatus: PropTypes.func.isRequired,
  username: PropTypes.string.isRequired,
};

AutomatedJobsFilters.defaultProps = {
  isPerformanceEnabled: false,
  performance: null,
  togglePerformance: null,
};
export default AutomatedJobsFilters;
